import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import { Form, Validators } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import { iconsLibrary } from "../../../theme/constants";
import { NgxCSVParserError, NgxCsvParser } from "ngx-csv-parser";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { CompanyService } from "../../services/company.service";
import { showAlertAction } from "../../store/actions/alert.action";
import { CowingSecurityEncryptService } from "../../services/cowingSecurityEncrypt.service";

@Component({
  selector: "cowing-core-company-paymethods",
  templateUrl: "./company-paymethods.component.html",
  styleUrls: ["./company-paymethods.component.scss"],
})
export class CompanyPaymethodsComponent implements OnInit, OnDestroy {
  @Input("form") form: FormGroup;
  @Input("secondForm") secondForm: FormGroup;
  @Output("location") location = new EventEmitter();
  public EInputStyleType = EInputStyleType;
  public EInputMediaStyleType = EInputMediaStyleType;
  public EButtonType = EButtonType;
  public ETextareaStyleType = ETextareaStyleType;
  showBankInfoForm = true;
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
    private companyService: CompanyService,
    private translate: TranslateService,
    private cowingSecurityEncryptService: CowingSecurityEncryptService
  ) {}
  async ngOnInit() {
    const companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    if (companyId && this.isEditingInfo) {
      this._store.dispatch(showLoadingAction({}));
      try {
        const response = await this.companyService.getCompanyPaymentInfo(
          companyId
        );
        const responseDecrypted =
          this.cowingSecurityEncryptService.decrypt(response);
        if (Object.keys(responseDecrypted).indexOf("owner")) {
          this.showBankInfoForm = false;
          this.secondForm.patchValue({ ...JSON.parse(responseDecrypted) });
          this.secondForm.disable();
        } else {
          this.showBankInfoForm = true;
          this.form.patchValue({ ...JSON.parse(responseDecrypted) });
          this.form.disable();
        }
      } catch (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      } finally {
        this._store.dispatch(closeLoadingAction({}));
      }
    }
  }

  public toggleForm() {
    this.form.reset();
    this.secondForm.reset();
    this.showBankInfoForm = !this.showBankInfoForm;
  }
  public get isEditingInfo() {
    return this.router.url === "/company-paymethods" ? true : false;
  }
  public setLocation(currentLocation) {
    !this.isEditingInfo
      ? this.location.emit(currentLocation)
      : this._setLocation(currentLocation);
  }
  public _setLocation(location) {
    this.form.get("city").setValue(location.city);
    this.form.get("country").setValue(location.country);
    this.form.get("province").setValue(location.province);
  }
  public goBack() {
    this.router.navigate(["company-home"]);
  }

  public get getEmployeesSvg() {
    return `${iconsLibrary.employeesSvg}`;
  }

  public get isDisabledForm() {
    // console.log(this.form);
    return this.form.dirty && this.form.valid ? false : true;
  }
  ngOnDestroy() {
    // this.form.get("is_business_group").valueChanges.
  }
}
